import { useAppSelector } from "redux-share";
import { conditions } from "../../../../../helpers";
import { ConditionName, ILikeIconProps } from "../../../../../interfaces";
import { shallowEqual } from "react-redux";

const LikeIcon = (props: ILikeIconProps) => {
    const { videoSettings } = useAppSelector(({ user: { videoSettings } }) => ({ videoSettings }), shallowEqual);
    useAppSelector(
        ({ videoData: { isComplexPortrait, videoElementSizeInfo, params } }) => ({ isComplexPortrait, videoElementSizeInfo, params }),
        shallowEqual
    );
    useAppSelector(({ controller: { showMiniPlayer } }) => ({ showMiniPlayer }), shallowEqual);

    return (
        <>
            {conditions(ConditionName.isSplusEnvironment) ? (
                <i
                    className={`${
                        props.isLike === true ? "fa-solid" : "fa-light"
                    } fa-thumbs-up fa-flip-horizontal pl-text-white pl-cursor-pointer pl-flex pl-items-center ${
                        conditions(ConditionName.isMiniPlayer) ? "pl-text-[13px]" : "pl-text-[22px]"
                    }`}
                    onClick={props.onClick}
                    onDoubleClick={props.onDoubleClick}
                />
            ) : (
                <svg
                    width={conditions(ConditionName.isMiniPlayer) ? 13 : conditions(ConditionName.isComplexPortrait) ? 16 : 22}
                    height={conditions(ConditionName.isMiniPlayer) ? 13 : conditions(ConditionName.isComplexPortrait) ? 16 : 22}
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={props.onClick}
                    onDoubleClick={props.onDoubleClick}
                    className={props.className}
                >
                    <path d="M14.3096 16.9492V7.63583C14.3096 7.26916 14.1996 6.91166 13.9979 6.60916L11.4954 2.8875C11.1012 2.29166 10.1204 1.87 9.28624 2.18166C8.3879 2.48416 7.79207 3.4925 7.98457 4.39083L8.46124 7.38833C8.4979 7.66333 8.42457 7.91083 8.26874 8.10333C8.1129 8.2775 7.88374 8.3875 7.63624 8.3875H3.86874C3.14457 8.3875 2.52124 8.68083 2.15457 9.19416C1.80624 9.68916 1.74207 10.3308 1.97124 10.9817L4.22624 17.8475C4.5104 18.9842 5.7479 19.91 6.97624 19.91H10.5512C11.1654 19.91 12.0271 19.6992 12.4212 19.305L13.5946 18.3975C14.0437 18.0583 14.3096 17.5175 14.3096 16.9492Z" />
                    <path d="M17.2245 5.84766H18.1687C19.5895 5.84766 20.167 6.39766 20.167 7.75432V16.976C20.167 18.3327 19.5895 18.8827 18.1687 18.8827H17.2245C15.8037 18.8827 15.2262 18.3327 15.2262 16.976V7.75432C15.2262 6.39766 15.8037 5.84766 17.2245 5.84766Z" />
                </svg>
            )}
        </>
    );
};

export default LikeIcon;
